<div *ngIf="noticeBoard" class="fw-bold mt-0" [innerHtml]="noticeBoard.content">
</div>
<div *ngIf="noticeBoard" class="d-flex align-items-between mb-1">
  <div *ngIf="noticeBoard.updatedAt" class="mr-md-auto">
    <small class="align-middle">{{ noticeBoard.updatedAt | date }}</small>
  </div>
  <div *ngIf="noticeBoard.mediaFile">
    <a target="_blank" [href]='noticeBoard.mediaFile.mediaUrl' class="btn btn-sm btn-outline-primary">
      <span class="mr-2">Download </span><i-bs name="caret-down-fill" width="1em" height="1em"></i-bs>
    </a>
  </div>
</div>
